import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import BoehringerIngelheim from "~/images/BoehringerIngelheim.png";
import RetailDesignationForm from "./RetailDesignationsForm";
import OfevDesignationForm from "./OfevDesignationsForm";

const BoehringerIngelheimDesignations = (props) => {
  const manufacturer_name = "boehringer_ingelheim";
  const vanity_manufacturer_name = "Boehringer Ingelheim";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] = useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    boehringer_ingelheim: {},
  });

  useEffect(() => {
    props.setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  const renderRetail = () => {
    if (props.renderRetail) {
      return (
        <RetailDesignationForm
          entity={props.entity}
          manufacturerFormDetails={manufacturerFormDetails}
          setManufacturerFormDetails={setManufacturerFormDetails}
          manufacturer={manufacturer_name}
          manufacturerName={vanity_manufacturer_name}
          setRetailSelectedSpecialtyPharmacy={setRetailSelectedSpecialtyPharmacy}
          setRetailHasSelectedSpecialtyPharmacy={setRetailHasSelectedSpecialtyPharmacy}
        />
      );
    }
  };

  const renderSpecialty = () => {
    if (props.renderSpecialty) {
      return (
        <OfevDesignationForm
          entity={props.entity}
          specialtyKeyName={"ldn"}
          manufacturerFormDetails={manufacturerFormDetails}
          setManufacturerFormDetails={setManufacturerFormDetails}
          manufacturer={manufacturer_name}
          manufacturerName={vanity_manufacturer_name}
          retailSelectedSpecialtyPharmacy={retailSelectedSpecialtyPharmacy}
          retailHasSelectedSpecialtyPharmacy={retailHasSelectedSpecialtyPharmacy}
        />
      );
    }
  };

  return (
    <div className="designation_form__section">
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={BoehringerIngelheim} />
        </div>
        <div className="designation_form__section__header__title">{vanity_manufacturer_name}</div>
      </div>
      <div className="designation_form__section__body">
        {renderRetail()}
        {renderSpecialty()}
      </div>
    </div>
  );
};

export default BoehringerIngelheimDesignations;
